/**
 * Identifies which partner list `state.partners` holds, so a list view can tell
 * page 1 of its own list from leftovers of another view (or a single partner).
 */
export function partnersListScope ({ locationCode = null, categoryId = null, tagId = null }: { locationCode?: string | null, categoryId?: number | string | null, tagId?: number | string | null }): string {
  return [locationCode || '', categoryId || '', tagId || ''].join('|')
}
